export const refKey = "current";

// for caret position detection
export const CARET_DETECTOR = (
  <span style={{ color: "transparent" }}>{"\u200b"}</span>
);
